import { Page, usePermissions } from '@/permissions';
import { useAvailabilityList } from '@/pages/Availability.page/hooks/useAvailabilityList';

type UseAvailabilityAccess = {
  hasAccess: boolean;
  loading: boolean;
};

export const useAvailabilityPageAccess = (): UseAvailabilityAccess => {
  const { canAccess, loading: permissionsLoading } = usePermissions();
  const { loading: listLoading, restaurants } = useAvailabilityList();

  const loading = permissionsLoading || listLoading;
  const hasAccess = canAccess(Page.Availability) && !!restaurants.length && !loading;

  return { hasAccess, loading };
};
